import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { ModalProvider, ModalRoot } from 'components/core/ModalRoot.component';
import HISTORY from 'config/history.singleton';
import QUERY from 'config/query.singleton';
import STORE from 'config/store.singleton';
import { AccessProvider } from 'providers/Access.provider';
import { AppointmentMachineProvider } from 'providers/AppointmentMachineProvider.component';
import { DispatcherProvider } from 'providers/Dispatcher.provider';
import { GiltProvider } from 'providers/GILT.provider';
import { PaymentAuditProvider } from 'providers/PaymentAuditProvider.component';
import { PusherProvider } from 'providers/Pusher.provider';
import { SalonBasicInfoProvider } from 'providers/SalonBasicInfo.provider';
import { SelectorProvider } from 'providers/SelectorProvider.provider';
import { ThemeProvider } from 'providers/Theme.provider';

const Providers = ({ children }) => (
  <QueryClientProvider client={QUERY}>
    <Router history={HISTORY}>
      <ReduxProvider store={STORE}>
        <AppointmentMachineProvider>
          <DispatcherProvider store={STORE}>
            <SelectorProvider store={STORE}>
              <SalonBasicInfoProvider>
                <PusherProvider>
                  <ThemeProvider>
                    <AccessProvider>
                      <GiltProvider>
                        <PaymentAuditProvider>
                          <ModalProvider>
                            <ModalRoot />
                            {children}
                          </ModalProvider>
                        </PaymentAuditProvider>
                      </GiltProvider>
                    </AccessProvider>
                  </ThemeProvider>
                </PusherProvider>
              </SalonBasicInfoProvider>
            </SelectorProvider>
          </DispatcherProvider>
        </AppointmentMachineProvider>
      </ReduxProvider>
    </Router>
  </QueryClientProvider>
);

export default Providers;
